import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { scoreLabel } from "@/lib/constants";

export default function DashboardSearcher() {
  const [favorites, setFavorites] = useState([]);
  const [saved, setSaved] = useState([]);

  useEffect(() => {
    api.get("/favorites").then((r) => setFavorites(r.data)).catch(() => {});
    api.get("/saved-searches").then((r) => setSaved(r.data)).catch(() => {});
  }, []);

  return (
    <div className="px-6 md:px-12 lg:px-16 py-12">
      <div className="mb-8">
        <div className="label-mono mb-2 text-amber-500">§ mon espace</div>
        <h1 className="font-display text-4xl md:text-5xl">Mes recherches</h1>
      </div>

      <section className="mb-12">
        <h2 className="font-display text-2xl mb-4">Favoris</h2>
        {favorites.length === 0 ? (
          <div className="border border-zinc-800 p-10 text-center label-mono">Aucun favori. <Link to="/annonces" className="text-amber-500">Explorer les annonces →</Link></div>
        ) : (
          <div className="grid md:grid-cols-3 gap-px bg-zinc-800 border border-zinc-800">
            {favorites.map((l) => {
              const s = scoreLabel(l.score || 0);
              return (
                <Link to={`/annonces/${l.id}`} key={l.id} className="bg-zinc-950 hover:bg-zinc-900 p-4">
                  <div className="font-display text-lg">{l.title}</div>
                  <div className="label-mono">{l.city} · {l.surface_exploitable || l.surface_total}m²</div>
                  <div className={`font-mono-tech text-xs mt-2 ${s.color}`}>[ {l.score || 0} / 100 ]</div>
                </Link>
              );
            })}
          </div>
        )}
      </section>

      <section>
        <h2 className="font-display text-2xl mb-4">Recherches sauvegardées</h2>
        {saved.length === 0 ? (
          <div className="border border-zinc-800 p-10 text-center label-mono">Aucune recherche sauvegardée</div>
        ) : (
          <div className="border border-zinc-800 divide-y divide-zinc-800">
            {saved.map((s) => (
              <div key={s.id} className="p-4">
                <div className="font-display text-lg">{s.name}</div>
                <div className="label-mono">{Object.keys(s.filters).length} filtres</div>
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
